import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { take } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { CurrencySymbol } from 'src/app/models/country-code-mapper';
import { Purchase } from 'src/app/models/purchase.model';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/users.model';
import { DialogComponent } from '../dialog/dialog.component';
import { AdminUser } from 'src/app/models/admin-users.model';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

(window as any).html2canvas = html2canvas;
@Component({
  selector: 'app-purchase-row',
  templateUrl: './purchase-row.component.html',
  styleUrls: ['./purchase-row.component.scss'],
})
export class PurchaseRowComponent implements OnInit, OnDestroy {
  @Input() purchase: Purchase;

  @Input() user: User | AdminUser;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  @Output() onButtonClick = new EventEmitter();

  currencySymbol: CurrencySymbol;
  invoiceNumber: string;
  isPaddle = false;
  paddleInvoiceLink = '';

  constructor(
    private dialogService: NbDialogService,
    private toastr: NbToastrService,
    private http: HttpClient,
  ) {}

  async ngOnInit() {
    this.isPaddle = this.purchase.platform === 'paddle';
    this.currencySymbol = CurrencySymbol[this.purchase.currencyCode.toLocaleLowerCase()];
    this.invoiceNumber = this.isPaddle ? this.purchase.paddleOrderId : this.purchase.invoiceNumber?.toString().padStart(6, '0');
    this.paddleInvoiceLink = this.isPaddle ? `https://vendors.paddle.com/orders/detail/${this.purchase.paddleOrderId}` : '';
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  async downloadPdf() {
    this.toastr.info('Generating File', 'Receipt', { icon: 'download', duration: 5000 });

    const data = (await this.http
      .post(`${environment.functionsRootUrl}/invoice-getInvoiceHTML/`, { purchaseUid: this.purchase.uid })
      .toPromise()) as { html: string };

    const HTMLString = data.html
      .replace(/\"https:\/\/firebasestorage(.+)\"/g, '"https://i.imgur.com/praPc8j.png"')
      .replace('e2e1e0', 'fff');
    const HTMLStringContainer = document.createElement('div');
    HTMLStringContainer.innerHTML = HTMLString;
    HTMLStringContainer.style.padding = '100px';
    HTMLStringContainer.style.position = 'absolute';
    HTMLStringContainer.style.top = '-10000px';
    HTMLStringContainer.style.overflow = 'none';
    document.body.appendChild(HTMLStringContainer);

    html2canvas(HTMLStringContainer, { useCORS: true, logging: true }).then((canvas) => {
      // Few necessary setting options
      const imgWidth = 208;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
      pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Swift Receipt #${this.purchase.invoiceNumber}.pdf`); // Generated PDF
      this.toastr.info('Download Started', 'Receipt', { icon: 'download', duration: 5000 });
      document.body.removeChild(HTMLStringContainer);
    });
  }
  async openEmailDialog() {
    const result = await this.dialogService
      .open(DialogComponent, {
        context: {
          title: 'Email Receipt',
          body: `This will send details about this purchase to ${this.user.name} at ${this.user.email}`,
          cancel: 'Back',
          confirm: 'Send',
          confirmClickDelay: 1000,
        },
      })
      .onClose.pipe(take(1))
      .toPromise();

    if (result === 'confirm') {
      const t = this.toastr.info('Sending Email', 'Email', { icon: 'email-outline' });
      try {
        await this.http
          .post(`${environment.functionsRootUrl}/email-sendInvoice/`, { purchaseUid: this.purchase.uid, email: this.user.email })
          .toPromise();
        this.toastr.info('Email has been sent', 'Email', { icon: 'checkmark-circle-outline' });
      } catch (error) {
        console.error(error);
        alert(error);
      }
    }
  }
}
